<template>
    <div class="lang-switcher">
        <button
            type="button"
            class="lang-switcher__toggle"
            :aria-expanded="open ? 'true' : 'false'"
            aria-haspopup="true"
            aria-controls="lang-switcher-menu"
            :aria-label="$t('Nyelv') + ': ' + current.name"
            v-on:click="$emit('toggle')"
        >
            <img :src="current.flag" alt="" class="lang-switcher__flag" />
            <span class="lang-switcher__code d-none d-xl-inline">{{
                current.code
            }}</span>
        </button>
        <transition name="profile-pop">
            <ul
                class="lang-switcher__menu"
                id="lang-switcher-menu"
                role="menu"
                v-if="open"
            >
                <li
                    v-for="lang in languages"
                    v-bind:key="lang.code"
                    role="none"
                >
                    <button
                        type="button"
                        role="menuitemradio"
                        class="lang-switcher__option"
                        :class="{ active: lang.code === current.code }"
                        :aria-checked="
                            lang.code === current.code ? 'true' : 'false'
                        "
                        :lang="lang.code"
                        v-on:click="select(lang.code)"
                    >
                        <img
                            :src="lang.flag"
                            alt=""
                            class="lang-switcher__flag"
                        />
                        <span>{{ lang.name }}</span>
                    </button>
                </li>
            </ul>
        </transition>
    </div>
</template>

<script>
import { LANGUAGES, currentLocale, switchLanguage } from "@/core/locale";

export default {
    name: "LanguageSwitcher",
    props: {
        open: { type: Boolean, default: false }
    },
    data() {
        return { languages: LANGUAGES };
    },
    computed: {
        current() {
            return (
                LANGUAGES.find(l => l.code === currentLocale) || LANGUAGES[0]
            );
        }
    },
    methods: {
        select(code) {
            this.$emit("close");
            if (code !== currentLocale) {
                switchLanguage(code);
            }
        }
    }
};
</script>

<style>
.lang-switcher {
    position: relative;
}
.lang-switcher__toggle {
    display: flex;
    align-items: center;
    gap: 6px;
    background: none;
    border: 0;
    padding: 0;
    color: inherit;
    font: inherit;
    text-transform: uppercase;
    cursor: pointer;
}
.lang-switcher__flag {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
}
.lang-switcher__menu {
    position: absolute;
    right: 0;
    top: calc(100% + 12px);
    z-index: 1000;
    min-width: 170px;
    margin: 0;
    padding: 8px;
    list-style: none;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);
    text-align: left;
}
.lang-switcher__option {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 8px 10px;
    border: 0;
    border-radius: 8px;
    background: none;
    color: var(--text, #232323);
    font: inherit;
    text-transform: none;
    cursor: pointer;
}
.lang-switcher__option:hover,
.lang-switcher__option:focus-visible {
    background: var(--alt-bg, #f6f2ee);
}
.lang-switcher__option.active {
    font-weight: 700;
    color: var(--blue, #056e82);
}
</style>
